import { render, staticRenderFns } from "./estatisticas-reabertura.vue?vue&type=template&id=43aada52"
import script from "./estatisticas-reabertura.vue?vue&type=script&lang=js"
export * from "./estatisticas-reabertura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports